<template>
  <el-dialog title="变更" :visible.sync="visible" :close-on-click-modal="false" :close-on-press-escape="false" width="40%">
    <el-form :model="data" :rules="rules" ref="addForm" label-width="90px">
      <el-form-item label="变更类型:" prop="changeType">
            <el-radio-group v-model="data.changeType">
                <el-radio v-for="radio in typeOptions" :label="radio.code">{{radio.name}}</el-radio>
            </el-radio-group>
      </el-form-item>
      <el-form-item label="变更原因:" prop="changeReason">
        <el-input type="textarea" rows="3" v-model="data.changeReason" :maxlength="200" placeholder="请填写变更原因" clearable/>
      </el-form-item>
      <div class="m20">
          <h3>温馨提示</h3>
            <p>1.请选择需要变更的类型和填写变更说明；</p>
            <p>2.商机变更发起后需要进行内部审批，审批通过后商机状态变更；</p>
            <p>3.输单和无效类型的变更审批通过后不可恢复；挂起类型的变更后期可恢复商机跟进。</p>
      </div>
      
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="confirm">确认</el-button>
    </span>
  </el-dialog>

</template>

<script>
import UserSelect from "@/views/crm/components/userSelect";
import CompanyInput from "@/views/crm/components/companyInput";
import { mapState } from 'vuex'
import { createChangeApproval } from '@/api/crm/business'

export default {
  name: "addBusinessPlanDialog",
  props: {
  },
  data() {
    return {
      visible: false,
      typeOptions: [{
          name: '输单',
          code: 1
      },{
          name: '无效',
          code: 2
      },{
          name: '挂起',
          code: 3
      },],
      rules: {
        changeType: [
          {required: true, message: '请选择类型', trigger: 'change'}
        ],
        changeReason: [
          {required: true, message: '请填写变更原因', trigger: 'change'},
        ]
      },
      data: {
        businessId: null,
        changeReason: null,
        changeType: 1
      }
    };
  },
  computed: {
    ...mapState({
      currentUserId: state => state.user.userId
    })
  },
  watch: {
    visible (val) {
      if (!val) {
        this.resetForm("addForm");
      }
    }
  },
  methods: {
    open (id) {
        this.data.businessId = id
      this.visible = true;
    },
    handleFileChange (fileObjs) {
      this.data.fileObjs = fileObjs;
    },
    confirm () {
      this.$refs['addForm'].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '加载中',
            spinner: 'el-icon-loading'
          });
          createChangeApproval(this.data).then(response => {
            this.$emit('success')
            this.visible = false
            loading.close();
            this.msgSuccess("操作成功");
            this.$emit(success)
          }).catch(error => {
            loading.close()
          })
        } else {
          this.msgWarning("请检查必填项");
          return false;
        }
      });
    }
  }
};
</script>
